import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

const NotFound: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const backHref = isAuthenticated ? '/profile' : '/login';
  const backText = isAuthenticated ? 'Go to Profile' : 'Go to Login';

  return (
    <div style={{ padding: '24px', textAlign: 'center' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '12px' }}>404 — Page Not Found</h1>
      <p style={{ color: '#666', marginBottom: '24px' }}>
        The page you are looking for doesn’t exist or has been moved.
      </p>
      <Link to={backHref} style={{
        display: 'inline-block',
        padding: '10px 16px',
        background: '#4F46E5',
        color: '#fff',
        borderRadius: '8px',
        textDecoration: 'none'
      }}>
        {backText}
      </Link>
    </div>
  );
};

export default NotFound;
